module.exports = __webpack_public_path__ + "static/brinsop-logo-d0adff908e2c0c4a089469581e6cf756.png";